<template>
  <mdb-modal
    :remove-backdrop="true"
    :show="show"
    @close="close()"
    size="sm"
  >
    <mdb-modal-header class="aqua-gradient"/>
    <mdb-modal-body class="overflow-hidden d-flex">
      <div class="d-flex justify-content-center align-items-center">
        <mdb-input
          label="Price"
          v-model="price"
          :small="valid ? null : 'Value must be a number'"
          class="my-0 mr-3"
        />
        <div>
          <h5>{{ currency }}</h5>
        </div>
      </div>
    </mdb-modal-body>
    <mdb-modal-footer class="text-right">
      <mdb-btn
        :disabled="!valid"
        rounded
        size="sm"
        gradient="aqua"
        @click.native="close(price)"
        title="Save"
        icon="check"
      >Save</mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import {
  mdbInput,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbBtn
} from 'mdbvue'

export default {
  name: 'PriceModal',
  data () {
    return {
      price: null,
      currency: null,
      show: false,
      callback: price => { console.log('Price entered: ', price) }
    }
  },
  computed: {
    valid: function () {
      return !isNaN(this.price)
    }
  },
  methods: {
    close (price = null) {
      this.show = false
      if (price !== null) {
        this.callback(price)
      }
      this.price = null
      this.currency = null
      this.callback = price => { console.log('Price entered: ', price) }
    }
  },
  mounted () {
    this.$bus.$on('modal-price', ({price, currency, callback}) => {
      this.callback = callback
      this.currency = currency
      this.price = price
      this.show = true
    })
  },
  beforeDestroy () {
    this.$bus.$off('modal-price')
  },
  components: {
    mdbInput,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn
  }
}
</script>

<style lang="sass">
.modal-body
  max-height: 50vh
</style>



// WEBPACK FOOTER //
// src/components/PriceModal.vue